module.exports = __webpack_public_path__ + "img/symbol_1.586240c0.png";